import { ROLES } from 'config/roles';
import DashboardShell from 'layouts/DashboardShell';

/** Student dashboard chrome — DashboardShell scoped to the student nav set. */
export default function StudentLayout() {
  return <DashboardShell role={ROLES.STUDENT} />;
}
